"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocationBlocked = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const ui_react_1 = require("@streem/ui-react");
const LocationBlocked = ({ dismiss }) => {
    return ((0, jsx_runtime_1.jsx)(ui_react_1.Card, { children: (0, jsx_runtime_1.jsxs)(ui_react_1.Column, { children: [(0, jsx_runtime_1.jsx)(ui_react_1.Header, Object.assign({ bold: true, size: "large", style: { marginBottom: '1rem' } }, { children: "GPS Location Blocked" })), (0, jsx_runtime_1.jsx)(Text, Object.assign({ as: "p", light: true }, { children: "Your GPS location could not be shared because you have GPS permissions turned off." })), (0, jsx_runtime_1.jsx)(ConfirmButton, Object.assign({ variant: "primary", onClick: dismiss }, { children: "OK" }))] }) }));
};
exports.LocationBlocked = LocationBlocked;
const Text = (0, ui_react_1.styled)(ui_react_1.AppText) `
    margin-bottom: 1rem;
`;
const ConfirmButton = (0, ui_react_1.styled)(ui_react_1.Button) `
    align-self: flex-end;
`;
//# sourceMappingURL=location_blocked.js.map